import {
  Cancel01Icon,
  InformationCircleIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { IncomeType } from "shared/types";
import { cx, formatToCurrency } from "shared/utils";
import { DocType } from "../types";
import { IconButton, IconButtonSize } from "shared/components/IconButton";
import { incomeTypeOptions } from "shared/app/InviteAndCreateModal/slices/ManualApplication/slices/CombinedIncome/constants";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const ConfirmView = ({
  applicantFullName,
  applicantRole,
  incomeSource,
  incomeName,
  cents,
  isLoading,
  documentsCount,
  docType,
  onClose
}: {
  applicantFullName: string;
  applicantRole: string;
  incomeSource: IncomeType;
  // job title, company
  incomeName: string;
  cents: number;
  isLoading: boolean;
  documentsCount: number;
  docType: DocType;

  onClose?: () => void;
}) => {
  const mappedIncomeType =
    incomeTypeOptions.find(({ type }) => type === incomeSource)?.label ||
    incomeSource;

  return (
    <div className="p-6">
      <h1 className="text-xl text-content-1000 font-bold mb-2 relative">
        Confirm verification
        <IconButton
          HugeIcon={Cancel01Icon}
          size={IconButtonSize.SM}
          borderLess
          className="absolute -top-2 -right-2"
          onClick={onClose}
        />
      </h1>
      <p className="pb-6 border-b border-alpha-40 text-sm font-medium text-content-300">
        Please make sure everything is correct before proceeding
      </p>

      <div className="my-6 pb-6 border-b border-alpha-40 space-y-2">
        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <p>Uploaded documents</p>
          <p className="ml-auto">{documentsCount}x</p>
        </div>

        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <p>Document type</p>
          <p className="ml-auto">{docType}</p>
        </div>

        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <p>Person</p>
          <p className="ml-auto">{`${applicantFullName}, ${applicantRole}`}</p>
        </div>

        <div className="flex items-center gap-2 text-sm font-medium text-content-400">
          <p>Income source</p>
          <p className="ml-auto">{`${mappedIncomeType}, ${incomeName}`}</p>
        </div>
      </div>

      <div className="border-b border-alpha-40 flex justify-between text-base font-bold mb-6 pb-6">
        <p className="text-content-1000">Verification cost</p>

        <Badge
          className={cx(
            "!font-bold",
            isLoading
              ? "text-alpha-100 animate-pulse h-4 w-10 rounded-lg"
              : "text-content-400"
          )}
          size={BadgeSize.SM}
          variant={BadgeVariant.BASE}
        >
          {formatToCurrency(
            {
              cents,
              currency: "USD"
            },
            {
              minimumFractionDigits: 2
            }
          )}
        </Badge>
      </div>

      <div className="bg-warning-50 text-warning-700 px-6 py-4 rounded-lg border-alpha-100 flex gap-4 items-center">
        <HugeiconsIcon
          icon={InformationCircleIcon}
          size={20}
          className="shrink-0"
        />

        <p className="text-sm font-medium">
          Re-verifying this income source will replace the original verification
        </p>
      </div>
    </div>
  );
};
